import React, { useState, useEffect } from 'react';
import './App.css';
import UserManagement from './components/UserManagement';
import ApplicationList from './components/ApplicationList';
import Login from './components/Login';

interface User {
  id: number;
  username: string;
  email: string;
  full_name?: string;
  is_admin: boolean;
  is_active: boolean;
}

function App() {
  const [activeTab, setActiveTab] = useState<'applications' | 'users'>('applications');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState<User | null>(null);

  // Redirect non-admin users away from users tab
  useEffect(() => {
    if (currentUser && !currentUser.is_admin && activeTab === 'users') {
      setActiveTab('applications');
    }
  }, [currentUser, activeTab]);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('access_token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setIsAuthenticated(true);
      setCurrentUser(JSON.parse(userData));
    }
  }, []);

  const handleLogin = (token: string, user: User) => {
    setIsAuthenticated(true);
    setCurrentUser(user);
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setCurrentUser(null);
  };

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <div className="logo-title-container">
            <img 
              src="/assets/logos/celestial-logo.png" 
              alt="Celestial Systems" 
              className="app-logo"
            />
            <h1>Loan Origination System</h1>
          </div>
          <div className="user-info">
            <span>Welcome, {currentUser?.full_name || currentUser?.username}</span>
            {currentUser?.is_admin && <span className="admin-badge">Admin</span>}
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
        <nav className="nav-tabs">
          <button
            className={`tab ${activeTab === 'applications' ? 'active' : ''}`}
            onClick={() => setActiveTab('applications')}
          >
            Loan Applications
          </button>
          {currentUser?.is_admin && (
            <button
              className={`tab ${activeTab === 'users' ? 'active' : ''}`}
              onClick={() => setActiveTab('users')}
            >
              User Management
            </button>
          )}
        </nav>
      </header>
      
      <main className="main-content">
        {activeTab === 'applications' && <ApplicationList />}
        {activeTab === 'users' && currentUser?.is_admin && <UserManagement />}
      </main>
    </div>
  );
}

export default App;
